<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useLessonEditMenu } from '../../model/lessons/lesson-edit-menu.hook'
import LessonCustomerTimezone from './LessonCustomerTimezone.vue'

defineOptions({
  name: 'LessonEditMenu',
})

const {
  config,
} = useLessonEditMenu()
</script>

<template>
  <div class="lesson-edit-menu">
    <NavigationLinkTabs
      :config="config"
    />
    <LessonCustomerTimezone />
  </div>
</template>

<style scoped lang="scss" src="./LessonEditMenu.scss" />
